<script>
  // Wraps an async loader in a #await with themed loading + error states.
  // Usage: <Async {promise}>{#snippet children(data)}...{/snippet}</Async>
  let { promise, loading = 'Loading…', children } = $props();
</script>

{#await promise}
  <div class="state"><span class="spinner"></span>{loading}</div>
{:then data}
  {@render children(data)}
{:catch err}
  <div class="state error">⚠ {err.message}</div>
{/await}
